import { useCallback } from "react";
import { useCanGoBack, useRouter } from "@tanstack/react-router";
import Router from "next/router";
import Helper from "@/utils/helper";
import * as Enums from "@/utils/enums";

/**
 * Detail page route for an item of the given module, used to return the user to the
 * item a create page was opened from (the `module` / `moduleID` query params).
 */
export function getModuleItemUrl(module: any, itemID: any): string | null {
    if (itemID === undefined || itemID === null || itemID === '') return null;
    switch (Number(module)) {
        case Enums.Module.Customer:
            return `/customer/${itemID}`;
        case Enums.Module.JobCard:
            return `/job/${itemID}`;
        case Enums.Module.Query:
            return `/query/${itemID}`;
        case Enums.Module.Asset:
            return `/asset/${itemID}`;
        case Enums.Module.Quote:
            return `/quote/${itemID}`;
        case Enums.Module.Invoice:
            return `/invoice/${itemID}`;
        case Enums.Module.PurchaseOrder:
            return `/purchase/${itemID}`;
        case Enums.Module.Project:
            return `/project/${itemID}`;
        default:
            return null;
    }
}

/**
 * Returns a callback that takes the user back to the page they came from.
 * Falls back to `fallbackUrl` when there is no in-app history (e.g. the page was opened
 * directly or in a new tab). Route-change guards (Helper.preventRouteChange) still apply.
 */
export default function useNavigateBack(fallbackUrl: string) {
    const router = useRouter();
    const canGoBack = useCanGoBack();

    return useCallback(() => {
        if (canGoBack) {
            router.history.back();
        } else {
            Helper.nextRouter(Router.push, fallbackUrl);
        }
    }, [canGoBack, router, fallbackUrl]);
}
